import React, { type ReactNode } from 'react';

import { Footer, Header, Main } from './components';

import { GroupsBackground, Interior, InvitePageWrapper } from './styles';

export interface InvitePageProps {
    children: ReactNode;
}

export function InvitePage({ children }: InvitePageProps) {
    return (
        <InvitePageWrapper>
            <GroupsBackground>
                <Interior>{children}</Interior>
            </GroupsBackground>
        </InvitePageWrapper>
    );
}

InvitePage.Header = Header;
InvitePage.Footer = Footer;
InvitePage.Main = Main;
